import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import Countary from "./Countary";
import Selectcustom from "./Selectcustom";
import { useSelector, useDispatch } from "react-redux";
import {setFirstPage} from "../../store/addBusinessSlice";
import ErrorViewer from "../errorHandler/ErrorViewer";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
function Binfo() {
  const navigate = useNavigate();
  const dispatch = useDispatch();


  const [value, setValue] = useState();
  console.log("value",value);
  const nextpage = (val) => {
     dispatch(setFirstPage({businessName:val.businessName,businessEmail:val.businessEmail,businessWebsite:val.businessWebsite,phone_number:value,category:1}));
    navigate("/address");
  };


  const validationSchema = Yup.object().shape({
    businessEmail: Yup.string()
      .required("Username is required")
      .email("Please enter a valid email (e.g name@domain.com)."),
      businessName: Yup.string()
      .required("Business name is required"),
      businessWebsite: Yup.string()
      .required("Business website is required"),
      category: Yup.string()
   
  });
  let defaultValues = { businessEmail: "", businessName: "",businessWebsite:"",phone_number:"",category:1};
  const methods = useForm({
    mode: "onTouched",
    resolver: yupResolver(validationSchema),
    defaultValues,
  });
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = methods;

  return (
    <>
      <div
        className="d-flex align-items-center ps-3 pe-3 "
        style={{ height: "100vh", width: "100%" }}
      >
        <div className="container box_div">
          <div className="steper_div">
            <div className="num">
              <p>1</p>
            </div>
            <div className="border_bottom_div"></div>
            <div className="num2">
              <p>2</p>
            </div>
            <div className="border_bottom2_div"></div>
            <div className="num2">
              <p>3</p>
            </div>
            <div className="border_bottom2_div"></div>
            <div className="num2">
              <p>4</p>
            </div>
          </div>
          <div className="d-flex justify-content-center w-100">
            <div className="card_business">
              <p className="business_heading1_main">Add Business Detail</p>
              <div>
                <p className="business_label mt-4">Business Name</p>
                <input
                  className="input1"
                  name="businessName"
                  {...register("businessName")}
                  
                  placeholder="Cube Adx"
                />
                {errors.businessName && <ErrorViewer message={errors.businessName.message} />}
                <p className="business_label">Business Phone Number</p>
                <PhoneInput placeholder="+1490300330" value={value} onChange={setValue} className="input1" name="phone_number"/>
                {errors.phone_number && <ErrorViewer message={errors.phone_number.message} />}
                {/* <input className='input1' placeholder='Cube Adx' /> */}
                <p className="business_label">
                  Business Email
                  <span className="business_span"> (Optional)</span>{" "}
                </p>
                <input
                  className="input1"
                  name="businessEmail"
                  {...register("businessEmail")}
                  
                  placeholder="Message Services"
                />
                {errors.businessEmail && <ErrorViewer message={errors.businessEmail.message} />}
                <p className="business_label">Business Category</p>
                <Selectcustom placeholder={"Message Services"} />
                <p className="business_label">Business Website</p>
                <input
                  {...register("businessWebsite")}
                  name="businessWebsite"
                  className="input1"
                  
                  placeholder="https://cubeadx.com"
                />
                {errors.businessWebsite && <ErrorViewer message={errors.businessWebsite.message} />}
                <button className="next_btn" onClick={handleSubmit(nextpage)}>
                  NEXT
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Binfo;
